import { render, staticRenderFns } from "./SecurityNoticeModal.vue?vue&type=template&id=90776934&scoped=true"
import script from "./SecurityNoticeModal.vue?vue&type=script&lang=js"
export * from "./SecurityNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./SecurityNoticeModal.vue?vue&type=style&index=0&id=90776934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90776934",
  null
  
)

export default component.exports